import React from 'react';
import { BRAND, isStoreDownloadsLive } from '../../constants/brand';
import { useStoreNotify } from './StoreNotifyContext';

const AppStoreLink = ({ children, className }) => {
  const { openStoreNotify } = useStoreNotify();

  if (isStoreDownloadsLive() && BRAND.appStoreUrl) {
    return (
      <a
        href={BRAND.appStoreUrl}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Download ${BRAND.appName} on the App Store`}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={`store_badge_btn${className ? ` ${className}` : ''}`}
      onClick={openStoreNotify}
      aria-label={`Get notified when ${BRAND.appName} is on the App Store`}
    >
      {children}
    </button>
  );
};

export default AppStoreLink;
